export const TOKEN_STORAGE_KEY = 'chianti_token';
export const REMENBER_PASSWORD_SWITCH_STORAGE_KEY = 'remember_password';

export const TAG_TYPE = {
  male: 'success',
  female: 'warning',
  unknown: 'info',
  init: 'info',
  completed: 'success',
  applied: 'warning',
  refunding: 'danger',
  cancelled: 'info',
  closed: 'info',
  pending: 'warning',
  shipped: '',
  received: 'success',
  draft: 'info',
  published: 'success',
  success: 'success',
  fail: 'danger',
  delay: 'pending',
  refund_audit: 'warning',
  refunded: 'info'
}

export const PAGE_TYPE = {
  StaticPage: '静态页面',
  PresetPage: '内置页面'
}

export const PAGE_STATUS = ['draft', 'published']

export const CONTENT_TYPES = [
  'image',
  'video',
  'audio',
  'text',
  'xml',
  'json',
  'pdf',
  'sheet'
]

export const BANNER_PAGE_POSITIONS = [
  'event'
]

export const BANNER_KINDS = [
  'web_link',
  'image',
  'mp_link'
]

export const ARTICLE_TYPE = {
  'Article': '文章',
  'SpecialColumn': '专栏',
  'SeekTruthWeekly': '求真周刊',
  'SeekTruthVideo': '求真视频',
  'BookClub': '读书会',
  'BookList': '书单',
  'Podcast': '播客',
  'YouthCamp': '青训营'
};
